<template>
  <div class="contract-detail-container">
    <page-title :title="identityAuthType != 4 ? '创作者状态' : '文博机构'">
      <div style="display: flex; justify-content: space-between">
        <div class="title-status">{{ auditStatus }}</div>
        <div style="display: flex; align-items: center">
          <div
            @click="dialogVisibleHistory = true"
            style="
              margin-right: 10px;
              text-decoration: underline;
              color: #606266;
              cursor: pointer;
            "
          >
            操作记录
          </div>
          <el-button size="small" type="primary" @click="goback"
            >返回</el-button
          >
        </div>
      </div>
    </page-title>

    <div class="detail-content">
      <!-- 左侧内容区域 -->
      <div
        class="left-section"
        v-if="identityAuthType && identityAuthType != 4"
      >
        <el-card class="info-card">
          <h4 class="card-title">签约信息</h4>
          <el-form
            :model="contractForm"
            label-width="130px"
            size="small"
            disabled
          >
            <el-form-item label="上传作品类型：">
              <el-select v-model="contractForm.uploadType">
                <el-option label="图片" :value="1"></el-option>
                <el-option label="音频" :value="2"></el-option>
                <el-option label="视频" :value="3"></el-option>
                <!-- 可添加更多选项 -->
              </el-select>
            </el-form-item>
            <el-form-item label="上传作品：">
              <div class="image-container" v-if="contractForm.uploadType == 1">
                <div
                  class="image-item"
                  v-for="(image, index) in contractForm.uploadImages"
                  :key="index"
                >
                  <el-image
                    v-if="image && image.url"
                    :src="image.url"
                    class="images"
                    :preview-src-list="
                      contractForm.uploadImages.map((img) => img.url)
                    "
                  >
                    <div slot="error" class="image-placeholder">
                      图片{{ index + 1 }}
                    </div>
                  </el-image>
                  <div v-else class="image-placeholder">
                    图片{{ index + 1 }}
                  </div>
                </div>
              </div>
              <div class="image-container1" v-if="contractForm.uploadType == 2">
                <div
                  class="video-item"
                  v-for="(image, index) in contractForm.uploadImages"
                  :key="index"
                >
                  <img src="../../assets/images/v4.1/mp3logo.png" alt="" />
                  <audio ref="audioPlayer" :src="image.url" controls></audio>
                </div>
              </div>
              <div class="image-container2" v-if="contractForm.uploadType == 3">
                <div
                  class="video-item1"
                  v-for="(image, index) in contractForm.uploadImages"
                  :key="index"
                >
                  <video
                    ref="videoPlayer"
                    controls
                    :poster="`${image.url}?x-oss-process=video/snapshot,t_1000,f_jpg,w_300,h_300`"
                    :src="image.url"
                  ></video>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 右侧内容区域 -->
      <div class="right-section">
        <el-card class="info-card">
          <h4 class="card-title">认证信息</h4>
          <el-form :model="enterpriseInfo" label-width="170px" size="small">
            <el-form-item label="认证类型：">
              {{
                identityAuthType == 2
                  ? "企业"
                  : identityAuthType == 1
                  ? "个人"
                  : "事业单位"
              }}
            </el-form-item>

            <template v-if="identityAuthType != 1">
              <el-form-item
                :label="identityAuthType == 2 ? '企业名称：' : '事业单位名称：'"
              >
                {{ enterpriseInfo.enterpriseName }}
              </el-form-item>
              <el-form-item
                :label="
                  identityAuthType == 2
                    ? '营业执照注册号：'
                    : '事业单位法人证书编号：'
                "
              >
                {{ enterpriseInfo.businessLicenseCode }}
              </el-form-item>
              <el-form-item
                :label="
                  identityAuthType == 2
                    ? '营业执照扫描件：'
                    : '事业单位法人证书：'
                "
              >
                <el-image
                  v-if="enterpriseInfo.businessLicenseImage"
                  :src="formatUrl(enterpriseInfo.businessLicenseImage)"
                  :preview-src-list="[
                    formatUrl(enterpriseInfo.businessLicenseImage),
                  ]"
                  class="images1"
                >
                  <div slot="error" class="image-placeholder">营业执照</div>
                </el-image>
              </el-form-item>
              <el-form-item label="法定代表人姓名：">
                {{ enterpriseInfo.realName }}
              </el-form-item>
              <el-form-item label="法定代表人身份证号：">
                {{ enterpriseInfo.idcardCode }}
              </el-form-item>
              <el-form-item label="法定代表人身份证：">
                <el-image
                  v-if="enterpriseInfo.idcardFrontImage"
                  :src="formatUrl(enterpriseInfo.idcardFrontImage)"
                  :preview-src-list="[
                    formatUrl(enterpriseInfo.idcardFrontImage),
                  ]"
                  class="images1"
                >
                  <div slot="error" class="image-placeholder">身份证照片</div>
                </el-image>
                <el-image
                  v-if="enterpriseInfo.idcardBackImage"
                  :src="formatUrl(enterpriseInfo.idcardBackImage)"
                  :preview-src-list="[
                    formatUrl(enterpriseInfo.idcardBackImage),
                  ]"
                  class="images1"
                >
                  <div slot="error" class="image-placeholder">身份证照片</div>
                </el-image>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="真实姓名：">
                {{ enterpriseInfo.realName }}
              </el-form-item>
              <el-form-item label="身份证号：">
                {{ enterpriseInfo.idcardCode }}
              </el-form-item>
              <el-form-item label="所属行业：">
                {{ enterpriseInfo.industry }}
              </el-form-item>
              <el-form-item label="身份证照片：">
                <el-image
                  v-if="enterpriseInfo.idcardFrontImage"
                  :src="formatUrl(enterpriseInfo.idcardFrontImage)"
                  :preview-src-list="[
                    formatUrl(enterpriseInfo.idcardFrontImage),
                  ]"
                  class="images1"
                >
                  <div slot="error" class="image-placeholder">身份证照片</div>
                </el-image>
                <el-image
                  v-if="enterpriseInfo.idcardBackImage"
                  :src="formatUrl(enterpriseInfo.idcardBackImage)"
                  :preview-src-list="[
                    formatUrl(enterpriseInfo.idcardBackImage),
                  ]"
                  class="images1"
                >
                  <div slot="error" class="image-placeholder">身份证照片</div>
                </el-image>
              </el-form-item>
            </template>
          </el-form>
          <div style="margin-top: 50px" v-if="operationType == 'audit'">
            <el-button size="small" @click="refuse">审核拒绝</el-button>
            <el-button size="small" type="primary" @click="examineApprove"
              >审核通过</el-button
            >
          </div>
        </el-card>

        <el-card class="info-card" v-if="auditStatus === '审核拒绝'">
          <h4 class="card-title">拒绝原因</h4>
          <p>{{ rejectReason }}</p>
        </el-card>
      </div>
    </div>
    <el-dialog
      title="审核拒绝"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
    >
      <el-form
        :model="dialogForm"
        ref="dialogForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item
          label="审核拒绝原因"
          prop="reason"
          v-if="operationType !== 'detail'"
        >
          <el-input
            maxlength="200"
            show-word-limit
            v-model.trim="dialogForm.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入审核拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFun">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmOperation"
          :loading="loadingShow"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 历史记录 -->
    <el-dialog
      title="操作记录"
      :before-close="() => (dialogVisibleHistory = false)"
      :visible.sync="dialogVisibleHistory"
      width="50%"
      append-to-body
    >
      <div style="padding: 0 24px; max-height: 500px; overflow: auto">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in historyLists"
            :key="index"
            :timestamp="activity.submitTime"
          >
            <div>{{ activity.auditRecord }}</div>
            <div v-if="activity.cause" style="color: brown; margin: 6px 0">
              {{
                activity.auditRecord == "账号禁用"
                  ? "禁用原因："
                  : "解禁原因："
              }}{{ activity.cause }}
            </div>
            <div
              v-if="activity.auditRecord === '审核拒绝'"
              style="color: brown; margin: 6px 0"
            >
              审批拒绝原因：{{ activity.rejectCause }}
            </div>
            <div style="margin-top: 6px">操作员：{{ activity.userName }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleHistory = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import {
  getSignContract,
  updateStatus,
  getSignContractRecordList,
} from "@/api/consulting";
import { userInfoHeaderHttp } from "@/config/config";
export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      userInfoHeaderHttp: userInfoHeaderHttp,
      activeTab: "creatorStatus",
      dialogVisibleHistory: false, // 控制历史记录对话框的显示
      dialogVisible: false, // 控制对话框的显示
      dialogForm: {
        reason: "", // 操作原因
      },
      auditStatus: "",
      contractForm: {
        uploadType: "",
        uploadImages: [null, null, null, null, null, null], // 预留6个图片位置
      },
      isEnterprise: true,
      identityAuthType: "",
      enterpriseInfo: {
        enterpriseName: "",
        businessLicenseCode: "",
        businessLicenseImage: "",
        realName: "",
        idcardCode: "",
        idcardFrontImage: "",
        idcardBackImage: "",
      },
      rejectReason: "",
      operationType: "detail", // 操作类型，默认为详情
      rules: {
        reason: [
          { required: true, message: "请输入审核拒绝原因", trigger: "blur" },
        ],
      },
      loadingShow: false, // 加载中
      historyLists: [], // 历史记录列表
    };
  },
  mounted() {
    this.historyList(); // 初始化历史记录列表
    this.getSignContractData();
    this.operationType = this.$route.query.type || "detail"; // 获取路由参数中的操作类型，如果没有则默认为详情
  },
  methods: {
    formatUrl(url) {
      if (!url) return "";

      if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1) {
        return url;
      }
      return userInfoHeaderHttp + url;
    },

    historyList() {
      this.$ajax
        .get(getSignContractRecordList, {
          signId: this.$route.params.id,
          pageSize: 9999,
          pageNumber: 1,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.historyLists = res.data.data.records;
            console.log(this.historyLists);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    submit(num, text) {
      this.loadingShow = true;
      this.$ajax
        .post(updateStatus, {
          id: this.$route.params.id,
          status: +num,
          rejectCause: text,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            setTimeout(() => {
              this.loadingShow = false;
              this.$router.push({ path: "/contractManagement" });
            }, 300);
          } else {
            this.loadingShow = false;
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.loadingShow = false;
          this.$message.error(err.message);
        });
    },
    // 取消
    closeFun() {
      this.dialogVisible = false;
    },
    // 确定
    confirmOperation() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.submit(3, this.dialogForm.reason);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 审核拒绝
    refuse() {
      this.dialogForm.reason = "";
      this.dialogVisible = true;
    },
    // 审核通过
    examineApprove() {
      this.submit(2);
    },
    getSignContractData() {
      this.$ajax
        .get(getSignContract + this.$route.params.id)
        .then((res) => {
          console.log(res);

          if (res.data.code == 200) {
            let newData = res.data.data;
            // 1待审核 2审核通过(正常) 3审核未通过 4禁用
            switch (newData.status) {
              case 1:
                this.auditStatus = "待审核";
                break;
              case 2:
                this.auditStatus = "审核通过";
                break;
              case 3:
                this.auditStatus = "审核拒绝";
                break;
              case 4:
                this.auditStatus = "禁用";
                break;
              default:
                this.auditStatus = "待审核";
                break;
            }
            this.contractForm.uploadType = newData.worksType;
            this.contractForm.uploadImages = JSON.parse(newData.url); // 假设图片地址用逗号分隔
            this.isEnterprise = newData.identityAuthType == 2 ? true : false; // 企业或个人/事业单位
            this.identityAuthType = newData.identityAuthType;
            if (this.identityAuthType != 1) {
              // 企业 | 事业单位
              this.enterpriseInfo.enterpriseName = newData.enterpriseName; // 企业名称
              this.enterpriseInfo.businessLicenseCode =
                newData.businessLicenseCode; // 营业执照注册号
              this.enterpriseInfo.businessLicenseImage =
                newData.businessLicenseImage; // 营业执照
              this.enterpriseInfo.realName = newData.realName; // 法定代表人
              this.enterpriseInfo.idcardCode = newData.idcardCode; // 身份证号
              this.enterpriseInfo.idcardFrontImage = newData.idcardFrontImage; // 身份证正面
              this.enterpriseInfo.idcardBackImage = newData.idcardBackImage; // 身份证反面
            } else {
              // 个人
              this.enterpriseInfo.realName = newData.realName; // 真实姓名
              this.enterpriseInfo.idcardCode = newData.idcardCode; // 身份证号
              this.enterpriseInfo.idcardFrontImage = newData.idcardFrontImage; // 身份证正面
              this.enterpriseInfo.idcardBackImage = newData.idcardBackImage; // 身份证反面
              this.enterpriseInfo.industry = newData.industry; // 所属行业
            }
            this.rejectReason = newData.rejectCause || ""; // 拒绝原因
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.message);
        });
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-detail-container {
}

.detail-content {
  // display: flex;
  background-color: #ffffff;
}

.info-card {
  margin-bottom: 20px;

  .card-title {
    margin-bottom: 20px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
}

.image-container {
  display: flex;
  flex-wrap: wrap;
}

.image-item {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 10%;
  margin-right: 2%;

  /deep/ .images {
    width: 100%;
    border-radius: 14px;

    .el-image__inner {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }
  }
}

/deep/.images1 {
  width: 200px;
  height: 200px;
  border-radius: 14px;
  margin-right: 10px;
  .el-image__inner {
    object-fit: cover;
  }
}

.image-placeholder {
  width: 100%;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  background-color: #f5f7fa;
}

.title-status {
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.el-button--primary {
  color: #fff;
  background-color: #002b9c;
  border-color: #002b9c;
}
.image-container2 {
  display: flex;
  flex-wrap: wrap;
  .video-item1 {
    width: 200px;
    height: 200px;
    border-radius: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
    video {
      width: 100%;
      height: 100%;
      border-radius: 14px;
      // object-fit: cover;
    }
  }
}
.video-item {
  border: 1px dashed #d9d9d9;
  height: 50px;
  padding: 8px 14px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  width: 400px;
  border-radius: 8px;

  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-right: 20px;
  }
  audio {
    height: 50px;
    margin-right: 20px;
  }
}
</style>
